import { render } from "./NewValidationDialogHeader.vue?vue&type=template&id=2d1d6e5a"
import script from "./NewValidationDialogHeader.vue?vue&type=script&lang=js"
export * from "./NewValidationDialogHeader.vue?vue&type=script&lang=js"

import "./NewValidationDialogHeader.vue?vue&type=style&index=0&id=2d1d6e5a&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
